<template>
  <FormBlock>
    <FormHeading :h="3">{{ $tt('customer_details') }}</FormHeading>
    <AppRow sequence-two>
      <FullnameField v-model="client.name" :rules="[required]" />
      <PhoneField v-model="client.phone" :rules="[required]" name="phone" />
      <EmailField v-model="client.email" :hint="$tt(`ensure_correct_email_${country}`)" />
      <WhatsappAlertsCheckbox v-model="client.whatsappAlertsEnabled" />
    </AppRow>
  </FormBlock>
</template>

<script setup lang="ts">
import { countryKeyInjectionKey } from '~/assets/injection-keys';
import type { Client } from '~/types';
import WhatsappAlertsCheckbox from './WhatsappAlertsCheckbox.vue';

const country = inject(countryKeyInjectionKey)!;
const client = defineModel<Client>({ required: true }); 

const { required } = useValidation();
</script>